// extracted by mini-css-extract-plugin
export default {"viewTitle":"PJVaH3EBysfGdIqlZ4kN","edit":"AwWUCPPX404nRFe0qXg7","delete":"nqF6QwIo2um8Rv02u0cy"};